// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ee1ea89","453":"9cfef526","455":"5ff0bdd0","977":"91d90114"}[chunkId] + ".chunk.js";
};